export default "__VITE_ASSET__63cf91b1__"